import classNames from 'classnames';
import { FC } from 'react';

import { EventItem } from '@/entities/event';

import styles from './eventsList.module.scss';
import EventCard from '../event-card/EventCard';

interface EventsListProps {
  className?: string;
  events: EventItem[];
  isArchive?: boolean;
}

const EventsList: FC<EventsListProps> = ({ className, events, isArchive }) => {
  return (
    <section className={classNames(styles.list, className)}>
      {events.map((event) => (
        <EventCard key={event.id} event={event} isArchive={isArchive} />
      ))}
    </section>
  );
};

export default EventsList;
